import { DocumentsError } from './DocumentsBody.error';
import { DocumentsBodyProps } from './DocumentsBody.types';
import { DocumentsLoading } from './DocumentsBody.loading';
import { DocumentsBodyRaw } from './DocumentsBody.raw';

export function DocumentsBody(props: DocumentsBodyProps) {
  const { query, ...rest } = props;

  if (query.isLoading || query.isIdle) return <DocumentsLoading />;
  if (query.isError) return <DocumentsError />;

  return <DocumentsBodyRaw {...rest} query={query} />;
}
